import http from "@/utils/http";


export const queryDeptmentList = () =>{
	return http.get("/server/umsDepartment/list");
};

